import React from "react";
import { AdvertisingLayoutStyled, BannerImageStyled } from "./style";
var AdvertisingLayout = function (_a) {
    var children = _a.children;
    return (React.createElement(AdvertisingLayoutStyled, null,
        React.createElement(BannerImageStyled, null)));
};
export default AdvertisingLayout;
